export const SUSCRIPTION_USER = 'SUSCRIPTION_USER';
export const RESET_USER_SUBSCRIPTION = 'RESET_USER_SUBSCRIPTION';
export const SUSCRIPTION_USER_SUCCESS = 'SUSCRIPTION_USER_SUCCESS';
export const SUSCRIPTION_USER_FAILED = 'SUSCRIPTION_USER_FAILED';
export const SUSCRIPTION_USER_HAS_DISALLOW_PUSH = 'SUSCRIPTION_USER_HAS_DISALLOW_PUSH';
export const SET_NOTIFICATION_SUBSCRIPTIONID = 'SET_NOTIFICATION_SUBSCRIPTIONID';
export const SAVE_NOTIFICATION_SEARCH = 'SAVE_NOTIFICATION_SEARCH';
export const SAVE_NOTIFICATION_SEARCH_SUCCESS = 'SAVE_NOTIFICATION_SEARCH_SUCCESS';
export const SAVE_NOTIFICATION_SEARCH_FAILED = 'SAVE_NOTIFICATION_SEARCH_FAILED';
export const FETCH_NOTIFICATION_SEARCHES = 'FETCH_NOTIFICATION_SEARCHES';
export const FETCH_NOTIFICATION_SEARCHES_SUCCESS = 'FETCH_NOTIFICATION_SEARCHES_SUCCESS';
export const FETCH_NOTIFICATION_SEARCHES_FAILED = 'FETCH_NOTIFICATION_SEARCHES_FAILED';
export const LOCALFORAGE_NOTIFICATION_SUBSCRIPTIONID_KEY = 'notificationsSubscriptionId';
export const LOCALFORAGE_SUBSCRIPTIONID_ISUPDATED = 'subscriptionIsUpdated';
export const LOCALFORAGE_SUBSCRIPTIONID_RESET = 'subscriptionIsReset';
export const UPDATE_NOTIFICATION_SEARCH = 'UPDATE_NOTIFICATION_SEARCH';
export const UPDATE_NOTIFICATION_SEARCH_SUCCESS = 'UPDATE_NOTIFICATION_SEARCH_SUCCESS';
export const UPDATE_NOTIFICATION_SEARCH_FAILED = 'UPDATE_NOTIFICATION_SEARCH_FAILED';
export const UPDATE_USER_SUBSCRIPTION = 'UPDATE_USER_SUBSCRIPTION';
export const UPDATE_USER_SUBSCRIPTION_SUCCESS = 'UPDATE_USER_SUBSCRIPTION_SUCCESS';
export const RESTORE_USER_SUBSCRIPTION = 'RESTORE_USER_SUBSCRIPTION';
export const RESTORE_USER_SUBSCRIPTION_SUCCESS = 'RESTORE_USER_SUBSCRIPTION_SUCCESS';
export const RESTORE_USER_SUBSCRIPTION_FAILED = 'RESTORE_USER_SUBSCRIPTION_FAILED';
export const TRACKING_PERMISSIONS_REQUEST = 'request';
export const TRACKING_PERMISSIONS_ALLOW = 'allow';
export const TRACKING_PERMISSIONS_MIGRATED = 'migrated';
export const TRACKING_PERMISSIONS_DISALLOW = 'disallow';
export const TRACKING_PERMISSIONS_AUTO_DISALLOW = 'auto_disallow';
export const TRACKING_PERMISSIONS_CLOSE = 'close';
export const TRACKING_PERMISSIONS_CUSTOM_REQUEST = 'custom_request';
export const TRACKING_PERMISSIONS_CUSTOM_ALLOW = 'custom_allow';
export const TRACKING_PERMISSIONS_CUSTOM_DISALLOW = 'custom_disallow';
export const TRACKING_PERMISSIONS_CUSTOM_AUTO_DISALLOW = 'custom_auto_disallow';
export const TRACKING_PERMISSIONS_CUSTOM_CLOSE = 'custom_close';
export const TRACKING_STATUSES_NEW_SEARCH = 'new_search';
export const TRACKING_STATUSES_SUBSCRIBED = 'subscribed_search';
export const TRACKING_STATUSES_UNSUBSCRIBED = 'unsubscribed_search';

export const ORIGIN_BROWSER_NOTIFICATION = 63;



// WEBPACK FOOTER //
// ./app/Notifications/constants.js